import { getAxiosClient } from "../../axios-client";
import { DeleteAvailabilityBody, DeleteAvailabilityResponse } from "./types";

const axiosClient = getAxiosClient();
export const deleteAvailability = async (body: DeleteAvailabilityBody) => {
    return await axiosClient.ax.delete<DeleteAvailabilityResponse>("Availability/Delete", { data: body } );
};